import { useTranslation } from 'react-i18next';
import ShareMenu from './ShareMenu';
import {
  collectionJson, collectionLink, collectionMarkdown, collectionText, collectionTitle,
} from '../../utils/recordShare';

/*
 * "Share" on one field collection (2026-10-19): its link, the share sheet, a
 * text summary, and Markdown / JSON exports (utils/recordShare.js), built
 * from what this reader was sent. `field`: link to Field Mode's page of the
 * record (its collector's), else the Collections page's.
 */
export default function CollectionShare({ collection, identifications = [], vegetation = [], field = false,
  testid = 'collection-share' }) {
  const { t } = useTranslation('common');
  if (!collection?.sample_id) return null;
  const label = (key) => t(`recordShare.${key}`);
  const url = collectionLink(collection, { field });
  const base = String(collection.code || collection.qr_uid || collection.sample_id).replace(/[^A-Za-z0-9._-]+/g, '_');
  const extra = { identifications, vegetation };
  return (
    <ShareMenu testid={testid} title={collectionTitle(collection, label)} url={url}
      text={collectionText(collection, label)}
      exports={[
        { key: 'md', label: t('share.downloadMarkdown'), filename: `${base}.md`, mime: 'text/markdown',
          content: () => collectionMarkdown(collection, extra, label, url) },
        { key: 'json', label: t('share.downloadJson'), filename: `${base}.json`, mime: 'application/json',
          content: () => collectionJson(collection, extra, url) },
      ]} />
  );
}
